module.exports = __webpack_public_path__ + "img/access-light-ac.8c09b452.svg";